<template>
  <div>
    <v-row>
      <v-col cols="12" md="8">
        <v-card>
          <v-progress-linear
              :indeterminate="loading"
              height="4"
              style="padding:0; margin:0;"
          ></v-progress-linear>

          <v-container style="width: 90% !important;" class="my-10">
            <ValidationProvider
                :name="getStudentItemTitle(item)"
                :rules="getStudentItemRules(item)"
                mode="eager"
                ref="provider"
                v-bind:key="item.name"
                v-for="item in items"
            >
              <div slot-scope="{ errors }">
                <v-row no-gutters>
                  <!--Label for the form-->
                  <v-col
                      xs="12"
                      md="3"
                      style="height: 65px"
                      class="d-flex justify-end"
                  >
                    <div
                        class="d-flex align-center justify-end text-right mb-3"
                    >
                      <p
                          class="subtitle-3 font-weight-bold text--primary"
                          :style="{
                          color:
                            errors.length > 0
                              ? 'rgb(236 29 36) !important'
                              : '',
                          opacity: 0.8,
                          marginTop: '5px',
                          marginRight: '15px',
                        }"
                      >
                        {{ getStudentItemTitle(item) }}:
                      </p>
                    </div>
                  </v-col>

                  <!-- Text field -->
                  <v-col xs="12" md="9" style="height: 65px">
                    <v-text-field
                        dense
                        :name="item.name"
                        outlined
                        :placeholder="
                        item.rules && item.rules.includes('required')
                          ? 'Obavezno..'
                          : ''
                      "
                        :prepend-icon="item.icon"
                        v-if="
                        item.tag === 'input' &&
                        item.name==='first_name'
                      "
                        v-model="form[item.name]"
                        @blur="studentGenitive={name:'', genitive_male: '', genitive_female: ''},getGenitives([form[item.name]], 0)"
                    >
                    </v-text-field>
                    <v-text-field
                        dense
                        :name="item.name"
                        outlined
                        :placeholder="
                        item.rules && item.rules.includes('required')
                          ? 'Obavezno..'
                          : ''
                      "
                        :prepend-icon="item.icon"
                        v-if="
                        item.tag === 'input' &&
                        item.name==='birth_place'
                      "
                        v-model="form[item.name]"
                        @blur="studentBirthPlaceGenitive={name:'', genitive_male: ''}, getGenitives([form[item.name]], 0)"
                    >
                    </v-text-field>
                    <v-text-field
                        dense
                        :name="item.name"
                        outlined
                        :placeholder="
                        item.rules && item.rules.includes('required')
                          ? 'Obavezno..'
                          : ''
                      "
                        :prepend-icon="item.icon"
                        v-if="
                        item.tag === 'input' &&
                          item.name != 'address' &&
                          item.name != 'jmbg' && item.name != 'first_name' && item.name!='birth_place'
                      "
                        v-model="form[item.name]"
                    >
                    </v-text-field>
                    <v-text-field
                        dense
                        :name="item.name"
                        outlined
                        :placeholder="
                        item.rules && item.rules.includes('required')
                          ? 'Obavezno..'
                          : ''
                      "
                        :prepend-icon="item.icon"
                        v-if="item.tag === 'input' && item.name === 'address'"
                        v-model="address_parents"
                    >
                    </v-text-field>

                    <v-text-field
                        dense
                        :name="item.name"
                        outlined
                        :placeholder="
                        getStudentItemRules(item) && getStudentItemRules(item).includes('required')
                          ? 'Obavezno..'
                          : ''
                      "
                        :prepend-icon="item.icon"
                        v-if="item.tag === 'input' && item.name === 'jmbg'"
                        v-model="studentIdentityValue"
                        :disabled="resourceId > 0 && form.aai_email != null"
                        @blur="checkStudentIdentity"
                    >
                      <template #append-outer>
                        <v-tooltip bottom v-if="resourceId > 0 && form.aai_email != null">
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon v-bind="attrs" v-on="on">mdi-information-outline</v-icon>
                          </template>
                          <span>Ne možete urediti JMBG korisniku koji posjeduje eduID</span>
                        </v-tooltip>
                      </template>
                    </v-text-field>

                    <!-- Select field -->
                    <v-autocomplete
                        outlined
                        dense
                        :placeholder="item.rules ? 'Obavezno..' : ''"
                        :items="item.source"
                        :name="item.name"
                        :prepend-icon="item.icon"
                        item-text="text"
                        item-value="value"
                        v-if="item.tag === 'select' && item.name != 'township_id' && item.name !='citizenship'"
                        v-model="form[item.name]"
                    >
                    </v-autocomplete>
                    <v-autocomplete
                        outlined
                        dense
                        :placeholder="item.rules ? 'Obavezno..' : ''"
                        :items="item.source"
                        :name="item.name"
                        :prepend-icon="item.icon"
                        item-text="text"
                        item-value="value"
                        v-if="item.tag === 'select' && item.name ==='citizenship'"
                        v-model="form[item.name]"
                        @change="studentCitizenshipGenitive={name:'', genitive_male: ''},getGenitives([form[item.name]], 0)"
                    >
                    </v-autocomplete>
                    <v-autocomplete
                        outlined
                        dense
                        :placeholder="item.rules ? 'Obavezno..' : ''"
                        :items="item.source"
                        :name="item.name"
                        :prepend-icon="item.icon"
                        item-text="text"
                        item-value="value"
                        v-if="
                        item.tag === 'select' && item.name === 'township_id'
                      "
                        v-model="township_id"
                    >
                    </v-autocomplete>

                    <!-- Multiselect field -->

                    <v-autocomplete
                        outlined
                        dense
                        :placeholder="item.rules ? 'Obavezno..' : ''"
                        :items="item.source"
                        :name="item.name"
                        chips
                        multiple
                        v-if="item.tag === 'multiselect'"
                        v-model="form[item.name]"
                    >
                    </v-autocomplete>

                    <!-- HTML editor -->

                    <div style="height: 320px" v-if="item.tag === 'html'">
                      <br/>

                      <span class="subheading"> {{ item.title }} <br/> </span>

                      <vue-editor
                          :name="item.name"
                          style="height: 200px; margin-top: 5px;"
                          v-model="form[item.name]"
                      >
                      </vue-editor>

                      <!--
                      <p v-if="item.validate"
                         class="form-error" style="padding: 10px;">
                          Ovo polje je obavezno.
                      </p>
                      -->
                    </div>

                    <div
                        class="hidden-sm-and-up"
                        style="height: 60px;"
                        v-if="item.tag === 'html'"
                    ></div>

                    <!-- File(s) uploads -->

                    <div v-if="item.tag === 'file' || item.tag === 'files'">
                      <br/>

                      <span class="subheading">{{ item.title }} <br/> </span>

                      <vue-dropzone
                          :id="'dropZone_' + item.name"
                          :name="item.name"
                          :options="item.tag === 'file' ? dzSingle : dzMulti"
                          @vdropzone-complete="(file) => onFileUpload(file, item)"
                          style="margin-top: 5px;"
                          v-if="dropzones"
                      >
                      </vue-dropzone>
                    </div>

                    <!-- Date picker -->

                    <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                        v-if="item.tag === 'date'"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="form[item.name]"
                            label="Odaberite datum"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="form[item.name]" scrollable>
                      </v-date-picker>
                    </v-menu>

                    <!-- Time picker -->

                    <br v-if="item.tag === 'time'"/>

                    <v-time-picker
                        :landscape="false"
                        :name="item.name"
                        format="24hr"
                        v-if="item.tag === 'time'"
                        v-model="form[item.name]"
                    >
                    </v-time-picker>
                  </v-col>

                  <!--                  genitivi -->
                  <!--                  <template-->
                  <!--                      v-if="item.name==='first_name'"-->
                  <!--                  >-->
                  <!--                    <v-col-->
                  <!--                        xs="12"-->
                  <!--                        md="3"-->
                  <!--                        style="height: 65px"-->
                  <!--                        class="d-flex justify-end"-->
                  <!--                    >-->
                  <!--                      <div-->
                  <!--                          class="d-flex align-center justify-end text-right mb-3"-->
                  <!--                      >-->
                  <!--                        <p-->
                  <!--                            class="subtitle-3 font-weight-bold text&#45;&#45;primary"-->
                  <!--                            :style="{-->
                  <!--                          color:-->
                  <!--                            errors.length > 0-->
                  <!--                              ? 'rgb(236 29 36) !important'-->
                  <!--                              : '',-->
                  <!--                          opacity: 0.8,-->
                  <!--                          marginTop: '5px',-->
                  <!--                          marginRight: '15px',-->
                  <!--                        }"-->
                  <!--                        >-->
                  <!--                          {{ 'Genitiv' }}:-->
                  <!--                        </p>-->
                  <!--                      </div>-->
                  <!--                    </v-col>-->

                  <!--                    <v-col-->
                  <!--                        xs="12"-->
                  <!--                        md="1"-->
                  <!--                        style="height: 65px"-->
                  <!--                        class="d-flex justify-end"-->
                  <!--                    >-->
                  <!--                      <div-->
                  <!--                          class="d-flex align-center justify-end text-right mb-3"-->
                  <!--                      >-->
                  <!--                        <p-->
                  <!--                            class="subtitle-3 font-weight-bold text&#45;&#45;primary"-->
                  <!--                            :style="{-->
                  <!--                          color:-->
                  <!--                            errors.length > 0-->
                  <!--                              ? 'rgb(236 29 36) !important'-->
                  <!--                              : '',-->
                  <!--                          opacity: 0.8,-->
                  <!--                          marginTop: '5px',-->
                  <!--                          marginRight: '15px',-->
                  <!--                        }"-->
                  <!--                        >-->
                  <!--                          {{ 'sin' }}-->
                  <!--                        </p>-->
                  <!--                      </div>-->
                  <!--                    </v-col>-->

                  <!--                    <v-col xs="12" md="3" style="height: 65px">-->
                  <!--                      <v-text-field-->
                  <!--                          dense-->
                  <!--                          outlined-->
                  <!--                          v-model="studentGenitive.genitive_male"-->
                  <!--                          :disabled="genitives.filter(x=>x.name===form.first_name).length>0"-->
                  <!--                          @blur="saveGenitive({name: form.first_name, genitive_male: studentGenitive.genitive_male})"-->

                  <!--                      >-->
                  <!--                      </v-text-field>                  </v-col>-->

                  <!--                    <v-col-->
                  <!--                        xs="12"-->
                  <!--                        md="2"-->
                  <!--                        style="height: 65px"-->
                  <!--                        class="d-flex justify-end"-->
                  <!--                    >-->
                  <!--                      <div-->
                  <!--                          class="d-flex align-center justify-end text-right mb-3"-->
                  <!--                      >-->
                  <!--                        <p-->
                  <!--                            class="subtitle-3 font-weight-bold text&#45;&#45;primary"-->
                  <!--                            :style="{-->
                  <!--                          color:-->
                  <!--                            errors.length > 0-->
                  <!--                              ? 'rgb(236 29 36) !important'-->
                  <!--                              : '',-->
                  <!--                          opacity: 0.8,-->
                  <!--                          marginTop: '5px',-->
                  <!--                          marginRight: '15px',-->
                  <!--                        }"-->
                  <!--                        >-->
                  <!--                          {{ 'kći' }}-->
                  <!--                        </p>-->
                  <!--                      </div>-->
                  <!--                    </v-col>-->

                  <!--                    <v-col xs="12" md="3" style="height: 65px" >-->
                  <!--                      <v-text-field-->
                  <!--                          dense-->
                  <!--                          outlined-->
                  <!--                          v-model="studentGenitive.genitive_female"-->
                  <!--                          :disabled="genitives.filter(x=>x.name===form.first_name).length>0"-->
                  <!--                          @blur="saveGenitive({name: form.first_name, genitive_female: studentGenitive.genitive_female})"-->

                  <!--                      >-->
                  <!--                      </v-text-field>-->
                  <!--                    </v-col>-->

                  <!--                  </template>-->

                  <!--genitivi mjesto rodjenja-->
                  <template
                      v-if="item.name==='birth_place'"
                  >

                    <v-col
                        xs="12"
                        md="3"
                        style="height: 65px"
                        class="d-flex justify-end"
                    >
                      <div
                          class="d-flex align-center justify-end text-right mb-3"
                      >
                        <p
                            class="subtitle-3 font-weight-bold text--primary"
                            :style="{
                          color:
                            errors.length > 0
                              ? 'rgb(236 29 36) !important'
                              : '',
                          opacity: 0.8,
                          marginTop: '5px',
                          marginRight: '15px',
                        }"
                        >
                          {{ 'Rođen u' }}
                        </p>
                      </div>
                    </v-col>

                    <v-col xs="12" md="4" style="height: 65px">
                      <v-text-field
                          dense
                          outlined
                          v-model="studentBirthPlaceGenitive.genitive_male"
                          @blur="saveGenitive({name: form.birth_place, genitive_male: studentBirthPlaceGenitive.genitive_male})"

                      >
                      </v-text-field>
                    </v-col>

                  </template>

                  <!--genitivi nacionalnost-->
                  <template
                      v-if="item.name==='citizenship'"
                  >

                    <v-col
                        xs="12"
                        md="3"
                        style="height: 65px"
                        class="d-flex justify-end"
                    >
                      <div
                          class="d-flex align-center justify-end text-right mb-3"
                      >
                        <p
                            class="subtitle-3 font-weight-bold text--primary"
                            :style="{
                          color:
                            errors.length > 0
                              ? 'rgb(236 29 36) !important'
                              : '',
                          opacity: 0.8,
                          marginTop: '5px',
                          marginRight: '15px',
                        }"
                        >
                          {{ 'Državljanin' }}
                        </p>
                      </div>
                    </v-col>

                    <v-col xs="12" md="4" style="height: 65px">
                      <v-text-field
                          dense
                          outlined
                          v-model="studentCitizenshipGenitive.genitive_male"
                          @blur="saveGenitive({name: form.citizenship, genitive_male: studentCitizenshipGenitive.genitive_male})"

                      >
                      </v-text-field>
                    </v-col>
                  </template>


                </v-row>
              </div>
            </ValidationProvider>
          </v-container>
        </v-card>
      </v-col>

      <v-col cols="12" md="4">
        <div class="fix-element">
          <v-btn
              @click="saveResource()"
              color="primary"
              dark
              block
              width="100%"
          >
            Potvrdi
          </v-btn>

          <v-btn
              @click="goBack()"
              class="mt-4"
              color="primary"
              dark
              block
              outlined
          >
            Odustani
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" md="6">
        <v-card height="100%">
          <!--<v-progress-linear :indeterminate="loading" height="4" style="padding:0; margin:0;"></v-progress-linear>-->
          <v-card-title class="pb-0 mb-2 primary--text"
          >Podaci o roditelju/staratelju *
          </v-card-title
          >
          <div class="pl-4" style="display: flex; justify-content: space-between; align-items: flex-start;">

            <v-checkbox
                v-model="checkbox_parent1"
                @click="addAdressParent1()"
                label="Prepiši adresu i općinu prebivališta"
            ></v-checkbox>

            <v-btn v-if="form.parent_one != null && $checkPermission('button_for_delete_parent') "
                   class="mr-2"
                   color="primary"
                   dark
                   outlined @click="dialog_delete_parent1 = true">
              <v-icon color="red">mdi-account-off</v-icon>
              Obriši
            </v-btn>

          </div>

          <div
              style="height: 1px; background: linear-gradient(90deg,#fff,#084776,#fff);"
          ></div>

          <v-container style="width: 90% !important;" class="my-10 mt-2">
            <ValidationProvider
                :name="item.name"
                :rules="item.rules"
                mode="eager"
                ref="provider1"
                v-bind:key="item.name"
                v-for="item in items_parent1"
            >
              <div slot-scope="{ errors }">
                <v-row no-gutters>
                  <!--Label for the form-->
                  <v-col
                      xs="12"
                      md="3"
                      style="height: 65px"
                      class="d-flex justify-end"
                  >
                    <div
                        class="d-flex align-center justify-end text-right mb-3"
                    >
                      <p
                          class="subtitle-3 font-weight-bold text--primary"
                          :style="{
                          color:
                            errors.length > 0
                              ? 'rgb(236 29 36) !important'
                              : '',
                          opacity: 0.8,
                          marginTop: '5px',
                          marginRight: '15px',
                        }"
                      >
                        {{ item.title }}:
                      </p>
                    </div>
                  </v-col>

                  <!-- Text field -->
                  <v-col xs="12" md="9" style="height: 65px">
                    <v-text-field
                        dense
                        :name="item.name"
                        outlined
                        :placeholder="
                        item.rules && item.rules.includes('required')
                          ? 'Obavezno..'
                          : ''
                      "
                        :prepend-icon="item.icon"
                        v-if="
                        item.tag === 'input' &&
                          item.name != 'jmbg' &&
                          item.name != 'first_name' &&
                          item.name != 'last_name'
                      "
                        v-model="form_parent1[item.name]"
                        :disabled="parent1_is_check"
                    >
                    </v-text-field>
                    <v-text-field
                        dense
                        :name="item.name"
                        outlined
                        :placeholder="
                        item.rules && item.rules.includes('required')
                          ? 'Obavezno..'
                          : ''
                      "
                        :prepend-icon="item.icon"
                        v-if="item.tag === 'input' && item.name === 'jmbg'"
                        v-model="parent1_jmbg"
                        @blur="checkStudentJmbg(parent1_jmbg, 'parent_1')"
                        :disabled="parent1_is_check || (parent1_jmbg !== '' && form.parent_one.jmbg !== null)"
                    >

                    </v-text-field>
                    <v-text-field
                        dense
                        :name="item.name"
                        outlined
                        :placeholder="
                        item.rules && item.rules.includes('required')
                          ? 'Obavezno..'
                          : ''
                      "
                        :prepend-icon="item.icon"
                        v-if="item.tag === 'input' && item.name === 'first_name'"
                        v-model="parent1_first_name"
                        :disabled="parent1_is_check"
                        @blur="parentOneGenitive={name:'', genitive_male: '', genitive_female: ''},getGenitives([parent1_first_name], 1)"
                    >
                    </v-text-field>
                    <v-text-field
                        dense
                        :name="item.name"
                        outlined
                        :placeholder="
                        item.rules && item.rules.includes('required')
                          ? 'Obavezno..'
                          : ''
                      "
                        :prepend-icon="item.icon"
                        v-if="item.tag === 'input' && item.name === 'last_name'"
                        v-model="parent1_last_name"
                        :disabled="parent1_is_check"
                    >
                    </v-text-field>

                    <!--                    <v-text-field-->
                    <!--                        dense-->
                    <!--                        :name="item.name"-->
                    <!--                        outlined-->
                    <!--                        :placeholder="-->
                    <!--                        item.rules && item.rules.includes('required')-->
                    <!--                          ? 'Obavezno..'-->
                    <!--                          : ''-->
                    <!--                      "-->
                    <!--                        :prepend-icon="item.icon"-->
                    <!--                        v-if="-->
                    <!--                        item.tag === 'input' &&-->
                    <!--                        item.name==='birth_place'-->
                    <!--                      "-->
                    <!--                        v-model="form[item.name]"-->
                    <!--                        @blur="getGenitives([form[item.name]], 0)"-->
                    <!--                    >-->
                    <!--                    </v-text-field>-->


                    <!-- Select field -->
                    <v-autocomplete
                        outlined
                        dense
                        :placeholder="
                        item.rules && item.rules.includes('required')
                          ? 'Obavezno..'
                          : ''
                      "
                        :items="item.source"
                        :name="item.name"
                        :prepend-icon="item.icon"
                        item-text="text"
                        item-value="value"
                        v-if="item.tag === 'select'&& item.name !='citizenship'"
                        v-model="form_parent1[item.name]"
                        :disabled="parent1_is_check"
                    >
                    </v-autocomplete>
                    <v-autocomplete
                        outlined
                        dense
                        :placeholder="item.rules ? 'Obavezno..' : ''"
                        :items="item.source"
                        :name="item.name"
                        :prepend-icon="item.icon"
                        item-text="text"
                        item-value="value"
                        v-if="item.tag === 'select' && item.name ==='citizenship'"
                        v-model="form_parent1[item.name]"
                        @change="parentOneCitizenshipGenitive={name:'', genitive_male: ''},getGenitives([form_parent1[item.name]], 1)"
                    >
                    </v-autocomplete>

                    <!-- Multiselect field -->

                    <v-autocomplete
                        outlined
                        dense
                        :placeholder="item.rules ? 'Obavezno..' : ''"
                        :items="item.source"
                        :name="item.name"
                        chips
                        multiple
                        v-if="item.tag === 'multiselect'"
                        v-model="form_parent1[item.name]"
                        :disabled="parent1_is_check"
                    >
                    </v-autocomplete>

                    <!-- HTML editor -->
                    <div style="height: 320px" v-if="item.tag === 'html'">
                      <br/>

                      <span class="subheading"> {{ item.title }} <br/> </span>

                      <vue-editor
                          :name="item.name"
                          style="height: 200px; margin-top: 5px;"
                          v-model="form_parent1[item.name]"
                      >
                      </vue-editor>

                      <!--
                      <p v-if="item.validate"
                         class="form-error" style="padding: 10px;">
                          Ovo polje je obavezno.
                      </p>
                      -->
                    </div>

                    <div
                        class="hidden-sm-and-up"
                        style="height: 60px;"
                        v-if="item.tag === 'html'"
                    ></div>

                    <!-- File(s) uploads -->

                    <div v-if="item.tag === 'file' || item.tag === 'files'">
                      <br/>

                      <span class="subheading">{{ item.title }} <br/> </span>

                      <vue-dropzone
                          :id="'dropZone_' + item.name"
                          :name="item.name"
                          :options="item.tag === 'file' ? dzSingle : dzMulti"
                          @vdropzone-complete="(file) => onFileUpload(file, item)"
                          style="margin-top: 5px;"
                          v-if="dropzones"
                      >
                      </vue-dropzone>
                    </div>

                    <!-- Date picker -->

                    <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                        v-if="item.tag === 'date'"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="form_parent1[item.name]"
                            label="Odaberite datum"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="form_parent1[item.name]"
                          scrollable
                      >
                      </v-date-picker>
                    </v-menu>

                    <!-- Time picker -->

                    <br v-if="item.tag === 'time'"/>

                    <v-time-picker
                        :landscape="false"
                        :name="item.name"
                        format="24hr"
                        v-if="item.tag === 'time'"
                        v-model="form_parent1[item.name]"
                    >
                    </v-time-picker>
                  </v-col>

                  <!--                  genitivi -->
                  <template
                      v-if="item.name==='first_name'"
                  >
                    <v-col
                        xs="12"
                        md="3"
                        style="height: 65px"
                        class="d-flex justify-end"
                    >
                      <div
                          class="d-flex align-center justify-end text-right mb-3"
                      >
                        <p
                            class="subtitle-3 font-weight-bold text--primary"
                            :style="{
                          color:
                            errors.length > 0
                              ? 'rgb(236 29 36) !important'
                              : '',
                          opacity: 0.8,
                          marginTop: '5px',
                          marginRight: '15px',
                        }"
                        >
                        </p>
                      </div>
                    </v-col>

                    <v-col
                        xs="12"
                        md="1"
                        style="height: 65px"
                        class="d-flex justify-end"
                    >
                      <div
                          class="d-flex align-center justify-end text-right mb-3"
                      >
                        <p
                            class="subtitle-3 font-weight-bold text--primary"
                            :style="{
                          color:
                            errors.length > 0
                              ? 'rgb(236 29 36) !important'
                              : '',
                          opacity: 0.8,
                          marginTop: '5px',
                          marginRight: '15px',
                        }"
                        >
                          {{ 'sin' }}
                        </p>
                      </div>
                    </v-col>

                    <v-col xs="12" md="3" style="height: 65px">
                      <v-text-field
                          dense
                          outlined
                          v-model="parentOneGenitive.genitive_male"
                          @blur="saveGenitive({name: parent1_first_name, genitive_male: parentOneGenitive.genitive_male, genitive_female: parentOneGenitive.genitive_female})"
                      >
                      </v-text-field>
                    </v-col>

                    <v-col
                        xs="12"
                        md="2"
                        style="height: 65px"
                        class="d-flex justify-end"
                    >
                      <div
                          class="d-flex align-center justify-end text-right mb-3"
                      >
                        <p
                            class="subtitle-3 font-weight-bold text--primary"
                            :style="{
                          color:
                            errors.length > 0
                              ? 'rgb(236 29 36) !important'
                              : '',
                          opacity: 0.8,
                          marginTop: '5px',
                          marginRight: '15px',
                        }"
                        >
                          {{ 'kći' }}
                        </p>
                      </div>
                    </v-col>

                    <v-col xs="12" md="3" style="height: 65px">
                      <v-text-field
                          dense
                          outlined
                          v-model="parentOneGenitive.genitive_female"
                          @blur="saveGenitive({name: parent1_first_name,genitive_male:parentOneGenitive.genitive_male, genitive_female: parentOneGenitive.genitive_female})"

                      >
                      </v-text-field>
                    </v-col>

                  </template>

                  <!--genitivi mjesto rodjenja-->
                  <template
                      v-if="item.name==='birth_place'"
                  >

                    <v-col
                        xs="12"
                        md="3"
                        style="height: 65px"
                        class="d-flex justify-end"
                    >
                      <div
                          class="d-flex align-center justify-end text-right mb-3"
                      >
                        <p
                            class="subtitle-3 font-weight-bold text--primary"
                            :style="{
                          color:
                            errors.length > 0
                              ? 'rgb(236 29 36) !important'
                              : '',
                          opacity: 0.8,
                          marginTop: '5px',
                          marginRight: '15px',
                        }"
                        >
                          {{ 'Rođen u' }}
                        </p>
                      </div>
                    </v-col>

                    <v-col xs="12" md="4" style="height: 65px">
                      <v-text-field
                          dense
                          outlined
                          v-model="parentOneBirthPlaceGenitive.genitive_male"
                          @blur="saveGenitive({name: form_parent1.birth_place, genitive_male: parentOneBirthPlaceGenitive.genitive_male})"

                      >
                      </v-text-field>
                    </v-col>

                  </template>

                  <!--genitivi nacionalnost-->
                  <template
                      v-if="item.name==='citizenship'"
                  >

                    <v-col
                        xs="12"
                        md="3"
                        style="height: 65px"
                        class="d-flex justify-end"
                    >
                      <div
                          class="d-flex align-center justify-end text-right mb-3"
                      >
                        <p
                            class="subtitle-3 font-weight-bold text--primary"
                            :style="{
                          color:
                            errors.length > 0
                              ? 'rgb(236 29 36) !important'
                              : '',
                          opacity: 0.8,
                          marginTop: '5px',
                          marginRight: '15px',
                        }"
                        >
                          {{ 'Državljanin' }}
                        </p>
                      </div>
                    </v-col>

                    <v-col xs="12" md="4" style="height: 65px">
                      <v-text-field
                          dense
                          outlined
                          v-model="parentOneCitizenshipGenitive.genitive_male"
                          @blur="saveGenitive({name: form_parent1.citizenship, genitive_male: parentOneCitizenshipGenitive.genitive_male})"

                      >
                      </v-text-field>
                    </v-col>

                  </template>

                </v-row>
              </div>
            </ValidationProvider>
          </v-container>
        </v-card>
      </v-col>
      <v-col cols="12" md="6">
        <v-card class="text-center" height="100%">
          <!--<v-progress-linear :indeterminate="loading" height="4" style="padding:0; margin:0;"></v-progress-linear>-->
          <v-card-title class=" pb-0 mb-2 primary--text"
          >Podaci o roditelju/staratelju
          </v-card-title
          >
          <div class="pl-4" style="display: flex; justify-content: space-between; align-items: flex-start;">

            <div>
              <v-checkbox
                  v-model="checkbox"
                  :disabled="parent2_is_check"
                  :label="`Želite li ${parent2_first_name == '' ? 'unijeti' : 'urediti'} drugog roditelja/staratelja?`"
              ></v-checkbox>
              <v-checkbox
                  :disabled="!checkbox"
                  @click="addAdressParent2()"
                  v-model="checkbox_parent2"
                  class="mt-0"
                  label="Prepiši adresu i općinu prebivališta"
              ></v-checkbox>
            </div>
            <v-btn v-if="form.parent_two != null && $checkPermission('button_for_delete_parent')"
                   class="mr-2"
                   color="primary"
                   dark
                   outlined @click="dialog_delete_parent2 = true">
              <v-icon color="red">mdi-account-off</v-icon>
              Obriši
            </v-btn>
          </div>

          <div
              style="height: 1px; background: linear-gradient(90deg,#fff,#084776,#fff);"
          ></div>

          <v-container
              style="width: 90% !important;"
              class="my-10 mt-2 primary--text"
          >
            <ValidationProvider
                :name="item.name"
                :rules="item.rules"
                ref="provider2"
                v-bind:key="item.name"
                v-for="item in items_parent1"
            >
              <div slot-scope="{ errors }">
                <v-row no-gutters>
                  <!--Label for the form-->
                  <v-col
                      xs="12"
                      md="3"
                      style="height: 65px"
                      class="d-flex justify-end"
                  >
                    <div class="d-flex align-center justify-end mb-2">
                      <p
                          class="subtitle-3 font-weight-bold text--primary text-right mb-4"
                          :style="{
                          color:
                            errors.length > 0
                              ? 'rgb(236 29 36) !important'
                              : '',
                          opacity: 0.8,
                          marginRight: '15px',
                        }"
                      >
                        {{ item.title }}:
                      </p>
                    </div>
                  </v-col>

                  <!-- Text field -->
                  <v-col xs="12" md="9" style="height: 65px">
                    <v-text-field
                        dense
                        :name="item.name"
                        outlined
                        :placeholder="
                        item.rules && item.rules.includes('required')
                          ? 'Obavezno..'
                          : ''
                      "
                        :prepend-icon="item.icon"
                        v-if="
                        item.tag === 'input' &&
                          item.name != 'jmbg' &&
                          item.name != 'first_name' &&
                          item.name != 'last_name'
                      "
                        v-model="form_parent2[item.name]"
                        :disabled="!checkbox"
                    >
                    </v-text-field>
                    <v-text-field
                        dense
                        :name="item.name"
                        outlined
                        :placeholder="
                        item.rules && item.rules.includes('required')
                          ? 'Obavezno..'
                          : ''
                      "
                        :prepend-icon="item.icon"
                        v-if="item.tag === 'input' && item.name === 'jmbg'"
                        v-model="parent2_jmbg"
                        @blur="checkStudentJmbg(parent2_jmbg, 'parent_2')"
                        :disabled="!checkbox || (parent2_jmbg !== '' && form.parent_two.jmbg !== null)"
                    >
                    </v-text-field>
                    <v-text-field
                        dense
                        :name="item.name"
                        outlined
                        :placeholder="
                        item.rules && item.rules.includes('required')
                          ? 'Obavezno..'
                          : ''
                      "
                        :prepend-icon="item.icon"
                        v-if="item.tag === 'input' && item.name === 'first_name'"
                        v-model="parent2_first_name"
                        :disabled="!checkbox"
                        @blur="parentTwoGenitive={name:'', genitive_male: '', genitive_female: ''},getGenitives([parent2_first_name], 2)"
                    >
                    </v-text-field>
                    <v-text-field
                        dense
                        :name="item.name"
                        outlined
                        :placeholder="
                        item.rules && item.rules.includes('required')
                          ? 'Obavezno..'
                          : ''
                      "
                        :prepend-icon="item.icon"
                        v-if="item.tag === 'input' && item.name === 'last_name'"
                        v-model="parent2_last_name"
                        :disabled="!checkbox"
                    >
                    </v-text-field>

                    <!-- Select field -->
                    <v-autocomplete
                        outlined
                        dense
                        :placeholder="
                        item.rules && item.rules.includes('required')
                          ? 'Obavezno..'
                          : ''
                      "
                        :items="item.source"
                        :name="item.name"
                        :prepend-icon="item.icon"
                        item-text="text"
                        item-value="value"
                        v-if="item.tag === 'select'&& item.name !='citizenship'"
                        v-model="form_parent2[item.name]"
                        :disabled="!checkbox"
                    >
                    </v-autocomplete>
                    <v-autocomplete
                        outlined
                        dense
                        :placeholder="item.rules ? 'Obavezno..' : ''"
                        :items="item.source"
                        :name="item.name"
                        :prepend-icon="item.icon"
                        item-text="text"
                        item-value="value"
                        v-if="item.tag === 'select' && item.name ==='citizenship'"
                        v-model="form_parent2[item.name]"
                        @change="parentTwoCitizenshipGenitive={name:'', genitive_male: ''},getGenitives([form_parent2[item.name]], 2)"
                    >
                    </v-autocomplete>

                    <!-- Multiselect field -->

                    <v-autocomplete
                        outlined
                        dense
                        :placeholder="item.rules ? 'Obavezno..' : ''"
                        :items="item.source"
                        :name="item.name"
                        chips
                        multiple
                        v-if="item.tag === 'multiselect'"
                        v-model="form_parent2[item.name]"
                        :disabled="!checkbox"
                    >
                    </v-autocomplete>

                    <!-- HTML editor -->

                    <div style="height: 320px" v-if="item.tag === 'html'">
                      <br/>

                      <span class="subheading"> {{ item.title }} <br/> </span>

                      <vue-editor
                          :name="item.name"
                          style="height: 200px; margin-top: 5px;"
                          v-model="form_parent2[item.name]"
                      >
                      </vue-editor>

                      <!--
                      <p v-if="item.validate"
                         class="form-error" style="padding: 10px;">
                          Ovo polje je obavezno.
                      </p>
                      -->
                    </div>

                    <div
                        class="hidden-sm-and-up"
                        style="height: 60px;"
                        v-if="item.tag === 'html'"
                    ></div>

                    <!-- File(s) uploads -->

                    <div v-if="item.tag === 'file' || item.tag === 'files'">
                      <br/>

                      <span class="subheading">{{ item.title }} <br/> </span>

                      <vue-dropzone
                          :id="'dropZone_' + item.name"
                          :name="item.name"
                          :options="item.tag === 'file' ? dzSingle : dzMulti"
                          @vdropzone-complete="(file) => onFileUpload(file, item)"
                          style="margin-top: 5px;"
                          v-if="dropzones"
                      >
                      </vue-dropzone>
                    </div>

                    <!-- Date picker -->

                    <v-menu
                        v-model="menu"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                        v-if="item.tag === 'date'"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                            v-model="form_parent2[item.name]"
                            label="Odaberite datum"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                          v-model="form_parent2[item.name]"
                          scrollable
                      >
                      </v-date-picker>
                    </v-menu>

                    <!-- Time picker -->

                    <br v-if="item.tag === 'time'"/>

                    <v-time-picker
                        :landscape="false"
                        :name="item.name"
                        format="24hr"
                        v-if="item.tag === 'time'"
                        v-model="form_parent2[item.name]"
                    >
                    </v-time-picker>
                  </v-col>


                  <!--                  genitivi -->
                  <template
                      v-if="item.name==='first_name'"
                  >
                    <v-col
                        xs="12"
                        md="3"
                        style="height: 65px"
                        class="d-flex justify-end"
                    >
                      <div
                          class="d-flex align-center justify-end text-right mb-3"
                      >
                        <p
                            class="subtitle-3 font-weight-bold text--primary"
                            :style="{
                          color:
                            errors.length > 0
                              ? 'rgb(236 29 36) !important'
                              : '',
                          opacity: 0.8,
                          marginTop: '5px',
                          marginRight: '15px',
                        }"
                        >
                        </p>
                      </div>
                    </v-col>

                    <v-col
                        xs="12"
                        md="1"
                        style="height: 65px"
                        class="d-flex justify-end"
                    >
                      <div
                          class="d-flex align-center justify-end text-right mb-3"
                      >
                        <p
                            class="subtitle-3 font-weight-bold text--primary"
                            :style="{
                          color:
                            errors.length > 0
                              ? 'rgb(236 29 36) !important'
                              : '',
                          opacity: 0.8,
                          marginTop: '5px',
                          marginRight: '15px',
                        }"
                        >
                          {{ 'sin' }}
                        </p>
                      </div>
                    </v-col>

                    <v-col xs="12" md="3" style="height: 65px">
                      <v-text-field
                          dense
                          outlined
                          v-model="parentTwoGenitive.genitive_male"
                          @blur="saveGenitive({name: parent2_first_name, genitive_male: parentTwoGenitive.genitive_male, genitive_female: parentTwoGenitive.genitive_female})"

                      >
                      </v-text-field>
                    </v-col>

                    <v-col
                        xs="12"
                        md="2"
                        style="height: 65px"
                        class="d-flex justify-end"
                    >
                      <div
                          class="d-flex align-center justify-end text-right mb-3"
                      >
                        <p
                            class="subtitle-3 font-weight-bold text--primary"
                            :style="{
                          color:
                            errors.length > 0
                              ? 'rgb(236 29 36) !important'
                              : '',
                          opacity: 0.8,
                          marginTop: '5px',
                          marginRight: '15px',
                        }"
                        >
                          {{ 'kći' }}
                        </p>
                      </div>
                    </v-col>

                    <v-col xs="12" md="3" style="height: 65px">
                      <v-text-field
                          dense
                          outlined
                          v-model="parentTwoGenitive.genitive_female"
                          @blur="saveGenitive({name: parent2_first_name,genitive_male: parentTwoGenitive.genitive_male, genitive_female: parentTwoGenitive.genitive_female})"
                      >
                      </v-text-field>
                    </v-col>

                  </template>

                  <!--genitivi mjesto rodjenja-->
                  <template
                      v-if="item.name==='birth_place'"
                  >

                    <v-col
                        xs="12"
                        md="3"
                        style="height: 65px"
                        class="d-flex justify-end"
                    >
                      <div
                          class="d-flex align-center justify-end text-right mb-3"
                      >
                        <p
                            class="subtitle-3 font-weight-bold text--primary"
                            :style="{
                          color:
                            errors.length > 0
                              ? 'rgb(236 29 36) !important'
                              : '',
                          opacity: 0.8,
                          marginTop: '5px',
                          marginRight: '15px',
                        }"
                        >
                          {{ 'Rođen u' }}
                        </p>
                      </div>
                    </v-col>

                    <v-col xs="12" md="4" style="height: 65px">
                      <v-text-field
                          dense
                          outlined
                          v-model="parentTwoBirthPlaceGenitive.genitive_male"
                          @blur="saveGenitive({name: form_parent2.birth_place, genitive_male: parentTwoBirthPlaceGenitive.genitive_male})"

                      >
                      </v-text-field>
                    </v-col>

                  </template>

                  <!--genitivi nacionalnost-->
                  <template
                      v-if="item.name==='citizenship'"
                  >

                    <v-col
                        xs="12"
                        md="3"
                        style="height: 65px"
                        class="d-flex justify-end"
                    >
                      <div
                          class="d-flex align-center justify-end text-right mb-3"
                      >
                        <p
                            class="subtitle-3 font-weight-bold text--primary"
                            :style="{
                          color:
                            errors.length > 0
                              ? 'rgb(236 29 36) !important'
                              : '',
                          opacity: 0.8,
                          marginTop: '5px',
                          marginRight: '15px',
                        }"
                        >
                          {{ 'Državljanin' }}
                        </p>
                      </div>
                    </v-col>

                    <v-col xs="12" md="4" style="height: 65px">
                      <v-text-field
                          dense
                          outlined
                          v-model="parentTwoCitizenshipGenitive.genitive_male"
                          @blur="saveGenitive({name: form_parent2.citizenship, genitive_male: parentTwoCitizenshipGenitive.genitive_male})"
                      >
                      </v-text-field>
                    </v-col>

                  </template>

                </v-row>
              </div>
            </ValidationProvider>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog_check_student" persistent max-width="500">
      <v-card>
        <v-card-title
            style="padding-left: 44px; padding-top:30px;"
            class="mb-0 pb-0"
            primary-title
        >
          {{ student_jmbg }}
          - {{ student_check.full_name }}
        </v-card-title>
        <v-card-title
            style="padding-left: 44px; padding-top:30px;"
            class="mt-0 pt-0"
            primary-title
        >
          <span style="font-size: 13px;" class="grey--text pt-2"
          >*Dodijelite ulogu <b>učenik</b> korisniku za Vašu školu.</span
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="accent" @click="dialog_check_student = false">Ne</v-btn>
          <v-btn @click="addRoles()" color="primary" class="ml-3">Da</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_check_parent1" persistent max-width="500">
      <v-card>
        <v-card-title
            style="padding-left: 44px; padding-top:30px;"
            class="mb-0 pb-0"
            primary-title
        >
          {{ parent1_jmbg }}
          - {{ parent1_check.full_name }}
        </v-card-title>
        <v-card-title
            style="padding-left: 44px; padding-top:30px;"
            class="mt-0 pt-0"
            primary-title
        >
          <span style="font-size: 13px;" class="grey--text pt-2"
          >*Roditelj/staratelj postoji u sustavu. Želite li popuniti njegove
            podatke?</span
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="accent" @click="dialog_check_parent1 = false">Ne</v-btn>
          <v-btn @click="fillDataParent1()" color="primary" class="ml-3"
          >Da
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_check_parent2" persistent max-width="500">
      <v-card>
        <v-card-title
            style="padding-left: 44px; padding-top:30px;"
            class="mb-0 pb-0"
            primary-title
        >
          {{ parent2_jmbg }}
          - {{ parent2_check.full_name }}
        </v-card-title>
        <v-card-title
            style="padding-left: 44px; padding-top:30px;"
            class="mt-0 pt-0"
            primary-title
        >
          <span style="font-size: 13px;" class="grey--text pt-2"
          >*Roditelj/staratelj postoji u sustavu. Želite li popuniti njegove
            podatke?</span
          >
        </v-card-title>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="accent" @click="dialog_check_parent2 = false">Ne</v-btn>
          <v-btn @click="fillDataParent2()" color="primary" class="ml-3"
          >Da
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>


    <v-dialog v-model="dialog_delete_parent1" persistent max-width="500">
      <v-card>
        <v-card-title
            style="padding-top:30px;"
            class="mb-0 pb-0"
            primary-title
        >
          Potvrda brisanja
        </v-card-title>
<v-card-text>Jeste li sigurni da želite izbrisati roditelja/staratelja?</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>

          <v-btn color="accent" @click="dialog_delete_parent1 = false">Poništi</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="removeParent(1)" color="primary" class="ml-3">
            Obriši
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialog_delete_parent2" persistent max-width="500">
      <v-card>
        <v-card-title
            style="padding-top:30px;"
            class="mb-0 pb-0"
            primary-title
        >
          Potvrda brisanja
        </v-card-title>
        <v-card-text>Jeste li sigurni da želite izbrisati roditelja/staratelja?</v-card-text>

        <v-divider></v-divider>
        <v-card-actions>

          <v-btn color="accent" @click="dialog_delete_parent2 = false">Poništi</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="removeParent(2)" color="primary" class="ml-3"
          >Obriši
          </v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import {serverBus} from "../../main";
import {VueEditor} from "vue2-editor";
import VueDropzone from "vue2-dropzone";
import {extend, setInteractionMode, ValidationProvider} from "vee-validate";
import {digits, email, max, min, required} from "vee-validate/dist/rules";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import ApiV2 from "../../services/ApiV2";
// import FormGenerator from "../add/FormGenerator";
export default {
  components: {
    VueEditor,
    VueDropzone,
    ValidationProvider,
  },
  props: ["customTable"],
  created: function () {
    setInteractionMode("eager");
    extend("min", min);
    extend("max", max);
    extend("digits", digits);
    extend("email", email);
    extend("required", {...required, message: "Ovo polje je obavezno."});
    this.table = "ucenik";
    this.resourceId = this.$route.params.resource_id
        ? this.$route.params.resource_id
        : -1;
    // console.log(this.resourceId)
    this.getGeneralData();
    setTimeout(function () {
      serverBus.$emit("get-add-view-data");
    }, 30);
    let self = this;
    serverBus.$on("perform-action-after-save", function () {
      // self.$navigate("/admin/ucenik/pregled/" + self.id);
      self.$router.go(-1);

    });
    this.getResource();
    this.getResourceFormData();
    this.getResourceFormDataParent1();
    this.tableActive = this.table;
  },
  watch: {
    /* address_parents: function () {
      if (this.checkbox_parent1) {
        this.form_parent1['address'] = this.address_parents
      } else {
        delete this.form_parent1['address']
      }
    },
    township_id: function () {
      if (this.checkbox_parent1) {
        this.form_parent1['township_id'] = this.township_id
      } else {
        delete this.form_parent1['township_id']
      }
    } */
  },

  computed: {
    isStudentOibIdentity() {
      return this.resourceId > 0 && !this.form?.jmbg && !!this.form?.oib;
    },
    studentIdentityValue: {
      get() {
        return this.isStudentOibIdentity ? this.student_oib : this.student_jmbg;
      },
      set(value) {
        if (this.isStudentOibIdentity) {
          this.student_oib = value;
        } else {
          this.student_jmbg = value;
        }
      },
    },
  },

  methods: {
    saveItem() {
      serverBus.$emit("save-add-view-data");
    },
    getStudentItemTitle(item) {
      if (item.name === "jmbg" && this.isStudentOibIdentity) {
        return "OIB";
      }

      return item.title;
    },
    getStudentItemRules(item) {
      if (item.name === "jmbg" && this.isStudentOibIdentity) {
        return item.rules ? item.rules.replace("digits:13", "digits:11") : "digits:11";
      }

      return item.rules;
    },
    checkStudentIdentity() {
      if (!this.isStudentOibIdentity) {
        this.checkStudentJmbg(this.student_jmbg, "student");
      }
    },

    async getGenitives(namesArray, type) {
      let {data} = await ApiV2.get('name_cases', {
        params: {
          filter: {
            name: `i=${namesArray}`,
            school_id: localStorage.getItem('school_id')
          }
        }
      })
      data.data.forEach(genitive => {
        if (this.genitives.filter(x => x.name.toLowerCase() === genitive.name.toLowerCase()).length === 0) {
          this.genitives.push(genitive)
        }
      })
      switch (type) {
        case 0:
          if (this.genitives.filter(x => x.name.toLowerCase() === this.form?.first_name?.toLowerCase()).length > 0) {
            this.studentGenitive = this.genitives.filter(x => x.name.toLowerCase() === this.form.first_name.toLowerCase())[0]
          }
          if (this.genitives.filter(x => x.name.toLowerCase() === this.form?.citizenship?.toLowerCase()).length > 0) {
            this.studentCitizenshipGenitive = this.genitives.filter(x => x.name.toLowerCase() === this.form.citizenship.toLowerCase())[0]
          }
          if (this.genitives.filter(x => x.name.toLowerCase() === this.form?.birth_place?.toLowerCase()).length > 0) {
            this.studentBirthPlaceGenitive = this.genitives.filter(x => x.name.toLowerCase() === this.form.birth_place.toLowerCase())[0]
          }
          break;
        case 1:
          if (this.genitives.filter(x => x.name.toLowerCase() === this.parent1_first_name.toLowerCase()).length > 0) {
            this.parentOneGenitive = {...this.genitives.filter(x => x.name.toLowerCase() === this.parent1_first_name.toLowerCase())[0]}
          }
          if (this.genitives.filter(x => x.name.toLowerCase() === this.form_parent1.citizenship?.toLowerCase()).length > 0) {
            this.parentOneCitizenshipGenitive = this.genitives.filter(x => x.name.toLowerCase() === this.form_parent1.citizenship?.toLowerCase())[0]
          }
          if (this.genitives.filter(x => x.name.toLowerCase() === this.form_parent1.birth_place?.toLowerCase()).length > 0) {
            this.parentOneBirthPlaceGenitive = this.genitives.filter(x => x.name.toLowerCase() === this.form_parent1.birth_place?.toLowerCase())[0]
          }
          break;
        case 2:
          if (this.genitives.filter(x => x.name.toLowerCase() === this.parent2_first_name.toLowerCase()).length > 0) {
            this.parentTwoGenitive = this.genitives.filter(x => x.name.toLowerCase() === this.parent2_first_name.toLowerCase())[0]
          }
          if (this.genitives.filter(x => x.name.toLowerCase() === this.form_parent2.citizenship?.toLowerCase()).length > 0) {
            this.parentTwoCitizenshipGenitive = this.genitives.filter(x => x.name.toLowerCase() === this.form_parent2.citizenship?.toLowerCase())[0]
          }
          if (this.genitives.filter(x => x.name.toLowerCase() === this.form_parent2.birth_place?.toLowerCase()).length > 0) {
            this.parentTwoBirthPlaceGenitive = this.genitives.filter(x => x.name.toLowerCase() === this.form_parent2.birth_place?.toLowerCase())[0]
          }
          break;
      }
      // }
      //
      // this.isLoaded = true
    },
    async saveGenitive(newGenitive) {
      let {data} = await ApiV2.post('name_cases/save_by_name', newGenitive)
      if (this.genitives.filter(x => x.name === data.name).length === 0) {
        this.genitives.push(data)
      } else {
        this.genitives.filter(x => x.name === data.name)[0].genitive_male = data.genitive_male
        this.genitives.filter(x => x.name === data.name)[0].genitive_female = data.genitive_female
      }
      //   if(data){
      //   serverBus.$emit("show-snackbar", true);
      // } else {
      //   serverBus.$emit("show-snackbar", false);
      // }
    },
    getGeneralData() {
      this.$axios.post(this.table + "/opcenito").then((response) => {
        this.breadcrumbs = response.data["breadcrumbs"];
        this.breadcrumbs.push({text: "New item"});
        if (this.title === "") {
          this.title = response.data["title"];
        }
      });
    },
    getResourceFormData() {
      if (this.table === this.tableActive) return;
      this.items = null;
      this.$axios.post(this.table + "/obrazac").then((response) => {
        this.items = response.data;
        //Privremeno rješenje dok se ne popravi api
        //this.items[2].source = ['OŠ fra Grge Martića', 1, "1"]
      });
    },
    addAdressParent1() {
      if (this.checkbox_parent1) {
        this.form_parent1["address"] = this.address_parents;
        this.form_parent1["township_id"] = this.township_id;
      } else {
        delete this.form_parent1["address"];
        delete this.form_parent1["township_id"];
      }
    },
    addAdressParent2() {
      if (this.checkbox_parent2) {
        this.form_parent2["address"] = this.address_parents;
        this.form_parent2["township_id"] = this.township_id;
      } else {
        delete this.form_parent2["address"];
        delete this.form_parent2["township_id"];
      }
    },
    getResourceFormDataParent1() {
      if (this.table === this.tableActive) return;
      this.items_parent1 = null;
      this.$axios.post("roditelj/obrazac").then((response) => {
        this.items_parent1 = response.data;
      });
    },
    getResource() {
      if (this.resourceId < 0) return;
      ApiV2.get("users/" + this.resourceId, {
        params: {
          with: ["parentOne", "parentTwo", "StudentSchools"],
        },
      }).then((response) => {
        this.form = response.data;
        this.student_jmbg = this.form.jmbg;
        this.student_oib = this.form.oib;
        this.address_parents = this.form.address;
        this.township_id = this.form.township_id;
        this.getGenitives([this.form.first_name, this.form.citizenship, this.form.birth_place], 0)
        // console.log(this.form.parent_one)
        if (this.form.parent_one != null) {
          this.form_parent1 = this.form.parent_one;
          this.parent1_jmbg = this.form_parent1.jmbg;
          this.parent1_first_name = this.form_parent1.first_name;
          this.parent1_last_name = this.form_parent1.last_name;
          this.getGenitives([this.parent1_first_name, this.form_parent1.citizenship, this.form_parent1.birth_place], 1)
        }
        if (this.form.parent_two != null) {
          this.form_parent2 = this.form.parent_two;
          this.parent2_jmbg = this.form_parent2.jmbg;
          this.parent2_first_name = this.form_parent2.first_name;
          this.parent2_last_name = this.form_parent2.last_name;
          this.getGenitives([this.parent2_first_name, this.form_parent2.citizenship, this.form_parent2.birth_place], 2)
        }
        if (this.form.student_schools && this.form.student_schools.length > 0) {
          let school = this.form.student_schools.filter(
              (x) => x.school_id == localStorage.getItem("school_id")
          )[0];
          this.form.parish_register = school?.parish_register;
          this.form.parish_register_number =
              school?.parish_register_number;
        }

      });
      // this.$axios.post(this.table + '/' + this.resourceId).then(response => {
      //     this.form = response.data;
      // });
    },
    saveResource() {
      let errors = false;
      this.form["address"] = this.address_parents;
      this.form["township_id"] = this.township_id;
      if (this.isStudentOibIdentity) {
        this.form["oib"] = this.student_oib;
        delete this.form.jmbg;
      } else {
        this.form["jmbg"] = this.student_jmbg;
      }
      if (this.resourceId > 0 && this.form.aai_email != null) {
        delete this.form.jmbg;
        delete this.form.oib;
      }
      this.form_parent1["jmbg"] = this.parent1_jmbg;
      this.form_parent1["first_name"] = this.parent1_first_name;
      this.form_parent1["last_name"] = this.parent1_last_name;
      if (this.checkbox) {
        this.form_parent2["jmbg"] = this.parent2_jmbg;
        this.form_parent2["first_name"] = this.parent2_first_name;
        this.form_parent2["last_name"] = this.parent2_last_name;
      }
      // console.log(this.form)
      // console.log(this.resourceId)
      for (let i = 0; i < this.$refs.provider.length; i++) {
        this.$refs.provider[i].validate().then(() => {
          if (this.$refs.provider[i].errors.length > 0) {
            // for (let k = 0; k < this.$refs.provider1.length; k++) {
            //   this.$refs.provider1[k].validate().then(() => {
            //     if (this.$refs.provider1[k].errors.length > 0) {
            errors = true;
            //     }
            //   })
            // }
          }
        });
      }
      // if(Object.keys(this.form_parent2).length > 0) {
      //     errors = false;
      //     for (let j = 0; j < this.$refs.provider2.length; j++) {
      //         this.$refs.provider2[j].validate().then(() => {
      //             if (this.$refs.provider2[j].errors.length > 0) {
      //                 errors = true;
      //             }
      //         })
      //     }
      // }
      setTimeout(() => {
        if (!errors) {
          this.loading = true;
          // if (this.resourceId != null){
          //     delete this.form.relations
          // } else {
          // console.log(this.form)
          // console.log(this.resourceId)
          if (this.resourceId < 0) {
            this.form.relations.parentOne.data = [this.form_parent1];
            if (Object.keys(this.form_parent2).length > 0) {
              this.form.relations.parentTwo.data = [this.form_parent2];
            } else {
              delete this.form.relations.parentTwo;
            }
          } else {
            this.form.parent_one = this.form_parent1;
            this.form.parentOne = this.form.parent_one;
            delete this.form.parent_one;
            // Object.assign({}, this.form.parentOne)
            // console.log(this.form)
            if (Object.keys(this.form_parent2).length > 0) {
              this.form.parent_two = this.form_parent2;
              this.form.parentTwo = this.form.parent_two;
              delete this.form.parent_two;
              // Object.assign({}, this.form.parentTwo)
            }
          }
          // }
          if (!this.checkbox) {
            delete this.form.relations?.parentTwo;
            if (this.parent1_is_check) {
              delete this.form.relations;
              this.form["parent1_id"] = this.parent1_check.id;
            }
            if (this.parent2_is_check) {
              delete this.form.relations?.parentTwo;
              this.form["parent2_id"] = this.parent2_check.id;
            }
          } else {
            // console.log('123')
            if (this.parent1_is_check) {
              delete this.form.relations?.parentOne;
              this.form["parent1_id"] = this.parent1_check.id;
            }
            if (this.parent2_is_check) {
              delete this.form.relations?.parentTwo;
              this.form["parent2_id"] = this.parent2_check.id;
            }
          }
          if (
              this.parent1_first_name == "" &&
              this.parent1_last_name == "" &&
              this.parent2_first_name == "" &&
              this.parent2_last_name == ""
          ) {
            delete this.form.relations;
          } else if (
              this.parent1_first_name == "" &&
              this.parent1_last_name == ""
          ) {
            delete this.form.relations?.parentOne;
          } else if (
              this.parent2_first_name == "" &&
              this.parent2_last_name == ""
          ) {
            delete this.form.relations?.parentTwo;
          }
          // if ('first_name' in this.form_parent1 && 'last_name' in this.fform_parent1) {
          //   console.log('ima')
          // } else {
          //   delete this.form.relations?.parentOne
          // }
          //
          // if ('first_name' in this.form_parent2 && 'last_name' in this.form_parent2) {
          //   console.log('ima')
          // } else {
          //   delete this.form.relations?.parentTwo
          // }
          // console.log(this.form)
          if (this.resourceId < 0) {
            ApiV2.post("users/pupils", this.form)
                .then((response) => {
                  this.id = response.data.id;
                  // console.log(response.data.id)
                  serverBus.$emit("show-snackbar");
                  this.form = {
                    relations: {
                      parentOne: {
                        method: "associate",
                        data: [],
                      },
                      parentTwo: {
                        method: "associate",
                        data: [],
                      },
                    },
                  };
                  serverBus.$emit("close-add-view-dialog");
                  serverBus.$emit("perform-action-after-save");
                })
                .catch(function (error) {
                  if (error.response.status == 422) {
                    // console.log(error.response.data.errors)
                    for (let key in error.response.data.errors) {
                      // console.log(error.response.data.errors[key])
                      serverBus.$emit(
                          "show-snackbar",
                          false,
                          error.response.data.errors[key][0]
                      );
                    }
                  } else {
                    serverBus.$emit("show-snackbar", false);
                  }
                })
                .finally(() => {
                  serverBus.$emit("reload-all-data");
                  this.loading = false;
                });
          } else {
            // console.log('123')
            ApiV2.put("users/pupils/" + this.resourceId, this.form)
                .then((response) => {
                  this.id = response.data.id;
                  // console.log(response.data.id)
                  serverBus.$emit("show-snackbar");
                  this.form = {
                    relations: {
                      parentOne: {
                        method: "associate",
                        data: [],
                      },
                      parentTwo: {
                        method: "associate",
                        data: [],
                      },
                    },
                  };
                  serverBus.$emit("close-add-view-dialog");
                  serverBus.$emit("perform-action-after-save");
                })
                .catch(function (error) {
                  if (error.response.status == 422) {
                    // console.log(error.response.data.errors)
                    for (let key in error.response.data.errors) {
                      // console.log(error.response.data.errors[key])
                      serverBus.$emit(
                          "show-snackbar",
                          false,
                          error.response.data.errors[key][0]
                      );
                    }
                    // serverBus.$emit('show-snackbar', false, );
                    // console.log(error.response.data);
                    // console.log(error.response.status);
                    // console.log(error.response.headers);
                  } else {
                    serverBus.$emit("show-snackbar", false);
                  }
                })
                .finally(() => {
                  serverBus.$emit("reload-all-data");
                  this.loading = false;
                });
          }
        } else {
          serverBus.$emit(
              "show-snackbar",
              false,
              "Provjerite jeste li unijeli sva potrebna polja na ispravan način!"
          );
        }
      }, 120);
    },
    onFileUpload(file, item) {
      if (file.accepted) {
        if (item.tag === "file") {
          this.form[item.name] = file.xhr.response;
        } else if (item.tag === "files") {
          if (this.form[item.name] == null) this.form[item.name] = [];
          this.form[item.name].push(file.xhr.response);
        }
        serverBus.$emit("show-snackbar", true);
      } else {
        serverBus.$emit("show-snackbar", false);
      }
    },
    addRoles() {
      let reqBody = {
        jmbg: this.student_jmbg,
        organisationId: localStorage.getItem("school_id"),
        roleId: 10,
        organisationType: "School",
      };
      // console.log(this.form_role)
      this.$axios
          .post(
              "ostalo/uloga/korisnik/" + this.student_check.id + "/dodaj",
              reqBody
          )
          .then(() => {
            this.dialog = false;
            serverBus.$emit("show-snackbar", true);
            this.$navigate("/admin/ucenik/pregled/" + this.student_check.id);
          })
          .catch(function () {
            serverBus.$emit("show-snackbar", false);
          });
    },
    async removeParent(parent_number) {
      let requ = {parent: parent_number};

      await ApiV2.post("/users/pupils/" + this.resourceId + "/detach_parent", requ).then(() => {
        this.getResource();
        if (parent_number === 1) {

          this.form_parent1 = {};
          this.parent1_jmbg = '';
          this.parent1_first_name = '';
          this.parent1_last_name = '';
          this.parentOneCitizenshipGenitive = {};
          this.dialog_delete_parent1 = false;
        } else {
          this.form_parent2 = {};
          this.parent2_jmbg = '';
          this.parent2_first_name = '';
          this.parent2_last_name = '';
          this.parentTwoCitizenshipGenitive = {};
          this.dialog_delete_parent2 = false;

        }



        serverBus.$emit('show-snackbar', true, "Uspješno obrisan roditelj");
      })

    },
    checkStudentJmbg(value, text) {
      if (text == "student") {
        let reqBody = {
          jmbg: value,
        };
        ApiV2.post("check_jmbg/", reqBody).then((response) => {
          let check_jmbg = response.data;
          if (check_jmbg.exists) {
            this.student_check = response.data.user;
            this.dialog_check_student = true;
          }
        });
      } else if (text == "parent_1") {
        let reqBody = {
          jmbg: value,
        };
        ApiV2.post("check_jmbg/", reqBody).then((response) => {
          let check_jmbg = response.data;
          if (check_jmbg.exists) {
            this.parent1_check = response.data.user;
            this.dialog_check_parent1 = true;
          }
        });
      } else if (text == "parent_2") {
        let reqBody = {
          jmbg: value,
        };
        ApiV2.post("check_jmbg/", reqBody).then((response) => {
          let check_jmbg = response.data;
          if (check_jmbg.exists) {
            this.parent2_check = response.data.user;
            this.dialog_check_parent2 = true;
          }
        });
      }
    },
    fillDataParent1() {
      this.form_parent1 = this.parent1_check;
      this.parent1_first_name = this.parent1_check.first_name;
      this.parent1_last_name = this.parent1_check.last_name;
      this.parent1_is_check = true;
      this.checkbox_parent1 = false;
      this.dialog_check_parent1 = false;
    },
    fillDataParent2() {
      this.form_parent2 = this.parent2_check;
      this.parent2_first_name = this.parent2_check.first_name;
      this.parent2_last_name = this.parent2_check.last_name;
      this.parent2_is_check = true;
      this.checkbox = false;
      this.dialog_check_parent2 = false;
    },
    goBack() {
      this.$router.go(-1);
    },

  },
  beforeDestroy() {
    serverBus.$off("perform-action-after-save");
  },
  data: function () {
    return {
      studentIdentificationNumber: 'jmbg',
      dialog: false,
      isLoaded: false,
      dialog_check_student: false,
      dialog_check_parent1: false,
      dialog_delete_parent1: false,
      dialog_delete_parent2: false,
      dialog_check_parent2: false,
      loading: false,
      breadcrumbs: [],
      genitives: [],
      studentGenitive: {
        name: '',
        genitive_male: '',
        genitive_female: ''
      },
      studentBirthPlaceGenitive: {
        name: '',
        genitive_male: ''
      },
      studentCitizenshipGenitive: {
        name: '',
        genitive_male: ''
      },
      parentOneGenitive: {
        name: '',
        genitive_male: '',
        genitive_female: ''
      },
      parentOneBirthPlaceGenitive: {
        name: '',
        genitive_male: ''
      },
      parentOneCitizenshipGenitive: {
        name: '',
        genitive_male: ''
      },
      parentTwoGenitive: {
        name: '',
        genitive_male: '',
        genitive_female: ''
      },
      parentTwoBirthPlaceGenitive: {
        name: '',
        genitive_male: ''
      },
      parentTwoCitizenshipGenitive: {
        name: '',
        genitive_male: ''
      },
      id: "",
      table: "",
      title: "",
      resourceId: -1,
      parent1_first_name: "",
      parent1_last_name: "",
      parent2_first_name: "",
      parent2_last_name: "",
      checkbox: false,
      checkbox_parent1: false,
      address_parents: "",
      township_id: null,
      checkbox_parent2: false,
      student_check: [],
      parent1_check: [],
      parent2_check: [],
      parent1_is_check: false,
      parent2_is_check: false,
      student_jmbg: "",
      student_oib: "",
      parent1_jmbg: "",
      parent2_jmbg: "",
      form: {
        // country_of_birth: 'bih',
        relations: {
          parentOne: {
            method: "associate",
            data: [],
          },
          parentTwo: {
            method: "associate",
            data: [],
          },
        },
      },
      form_parent1: {
        address: "",
        township_id: null,
        // country_of_birth: 'bih',
      },
      form_parent2: {
        // country_of_birth: 'bih',
      },
      items: [],
      items_parent1: [],
      items_parent2: [],
      dropzones: true,
      tableActive: "",
      dzSingle: {
        url: "upload",
        method: "POST",
        maxFilesize: 20,
        maxFiles: 1,
        dictDefaultMessage: "Priložite datoteku..",
      },
      dzMulti: {
        url: "upload",
        method: "POST",
        maxFilesize: 20,
        dictDefaultMessage: "Priložite jednu ili više datoteka..",
      },
      //Date options
      date: new Date().toISOString().substr(0, 10),
      menu: false,
    };
  },
};
</script>
<style>
.fix-element {
  position: -webkit-sticky;
  position: sticky;
  top: 5rem;
  align-self: flex-start;
}
</style>
